import { applicationModuleRegistry } from '@philips-emr/tws-foundation';

import { Routes } from '../../definitions/routes';

export const DADOS_PESSOAIS = 'dados-pessoais';
export const DADOS_CONTRATO = 'dados-contrato';

export function setupMeuContrato(): void {
  const modules = [
    {
      entry: DADOS_PESSOAIS,
      id: DADOS_PESSOAIS,
      name: `beneficiary.${DADOS_PESSOAIS}`,
      route: Routes.DADOS_PESSOAIS,
      order: 1,
      closeable: true,
    },
    {
      entry: DADOS_CONTRATO,
      id: DADOS_CONTRATO,
      name: `beneficiary.${DADOS_CONTRATO}`,
      route: Routes.DADOS_CONTRATO,
      order: 2,
      closeable: true,
    },
    {
      entry: 'solicitar-cancelamento',
      id: 'solicitar-cancelamento',
      name: 'beneficiary.solicitar-cancelamento',
      route: Routes.SOLICITAR_CANCELAMENTO,
      order: 3,
      closeable: true,
    },
    {
      entry: 'historico-cancelamento',
      id: 'historico-cancelamento',
      name: 'beneficiary.historico-cancelamento',
      route: Routes.HISTORICO_CANCELAMENTOS,
      order: 4,
      closeable: true,
    },
  ];

  applicationModuleRegistry.registerGroup({
    entry: 'meu-contrato',
    id: 'meu-contrato',
    name: 'beneficiary.meu-contrato',
    modules,
    order: 2,
  });
}
